<template>
  <div class="howItWorksBanner">
    <div class="banner-container">
      <div class="how-it-works-image"></div>
        <div class="how-it-works-content">
        <div class="text-content">
          <h2 class="how-it-works-title title">How does <span class="gym-blue">MyGymChecker </span> work?</h2>
          <p class="subtitle is-4 non-mobile">MyGymChecker was created <b>by</b> gym users, <b>for</b> gym users. </p>
          <p class="subtitle is-4 mobile">MyGymChecker was created <b>by</b> gym users,<br /> <b>for</b> gym users. </p>
          <ul>
            <li class="how-it-works-subtitle my-2">
               MyGymChecker allows you to search through a <b>huge collection</b> of gyms across the UK.
            </li>
            <li class="how-it-works-subtitle my-2">
                Here you can discover the right gym for you with ease by using our <b>unique filter system</b>. Read each gym’s reviews left by previous users, and ensure the gym's facilities match your exact needs.
            </li>
            <li class="how-it-works-subtitle my-2">
                All you need to do to find your ideal gym is <b>enter your postcode</b> and hit <b>search</b>.
            </li>
          </ul>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

.banner-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40rem; 
  min-height: 600px;
}

.content-div {
  max-width: 80%; 
  margin: auto; 
  height: 0.25rem; 
  background: #00c5fd;
}

.howItWorksBanner {
  width: 100vw;
  /* box-shadow: 0px 0px 3px #b3b3b3; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: -5rem;
}


.how-it-works-content {
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  font-size: 1rem;
  width: 50vw;

}

@media (max-width: 1024px) {

  .banner-container {
    min-height: 30rem;
    height: auto;
    padding: 1rem 0;
    margin-top: 2rem;
  }
  .how-it-works-content {
    width: 100vw;
  }
  .title {
    text-align: center !important;
    font-size: 2rem !important;
  }
  .subtitle {
    text-align: center !important;
  }
  .mobile {
    display: block !important;
  }
  .non-mobile {
    display: none;
  }
}

.how-it-works-image {
  background: url('../../assets/images/Stock/pexels-timothy-700392.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  width: 50vw;
  height: 100%;
  /* min-height: 80vh; */
  align-items: center;
  border-top-right-radius: 25% 35%
}

ul{
  list-style-position: outside;
  margin: auto;
}

.how-it-works-subtitle {
  font-size: 1.5rem;
  color: #333333;
  padding: 0.5rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.mobile {
  display: none;
}

.text-content {
  padding-left: 1rem;
  padding-bottom: 3rem;
  max-width: 80%;
}

.subtitle {
  font-weight: 400 !important;
  color: #333333;
}


@media only screen and (max-width: 1024px){
  .howItWorksBanner{
    margin-bottom: 0;
  }

  .how-it-works-image{
    display: none;
  }
}

@media only screen and (max-width: 786px){
  .text-content{
    padding-left: 0;
  }
}

</style>